import generatePalette from './generate-palette';
import computeRuleset from './compute-ruleset';
import getColorTypeFromSchemeId from './get-color-type-from-scheme-id';
import { DEFAULT_COLOR_SCHEMES, CUSTOM_SCHEME_ID_RE } from '../constants/common';

export const buildRegistrySchemeEntry = ({
  schemeId,
  schemeData: { baseColor: baseColorValue, baseColorName, ...schemeData },
  context,
  rulesets,
  overrides = {},
}) => {
  const colorType = getColorTypeFromSchemeId(schemeId);
  const baseColor = baseColorValue || context.colors[baseColorName];
  const basePalette = baseColorName
    ? context.palettes[`${baseColorName}Palette`]
    : generatePalette(baseColor, colorType);

  return {
    ...schemeData,
    colorType,
    baseColor,
    basePalette,
    computedRules: computeRuleset(rulesets[colorType], {
      ...context,
      baseColor,
      basePalette,
    }),
    variableOverrides: { ...overrides },
  };
};

const buildColorSchemesRegistry = ({ context, rulesets, schemes = {} }) => {
  const defaultEntries = Object.entries(DEFAULT_COLOR_SCHEMES).map(([schemeId, baseColorName]) => [
    schemeId,
    buildRegistrySchemeEntry({
      schemeId,
      schemeData: { baseColorName },
      context,
      rulesets,
      overrides: schemes[schemeId]?.variableOverrides,
    }),
  ]);

  const customEntries = Object.entries(schemes)
    .filter(([id]) => CUSTOM_SCHEME_ID_RE.test(id))
    .map(([schemeId, { variableOverrides: overrides, ...schemeData }]) => [
      schemeId,
      buildRegistrySchemeEntry({
        schemeId,
        schemeData,
        context,
        rulesets,
        overrides,
      }),
    ]);

  return Object.fromEntries([...defaultEntries, ...customEntries]);
};

export default buildColorSchemesRegistry;
